import Editar from "../Consultas/Editar";
import HeaderRoot from "./HeaderRoot";




const Mostrar = () => {

    return (
        <>
            <HeaderRoot />
            <Editar />

        </>
    )
}

export default Mostrar
